import React, { Component } from 'react';
import axios from 'axios'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import { Button, Divider, Form } from 'semantic-ui-react'
import * as moment from 'moment';
import { base, serverIp, getOrderKey, toCurrency, pythonApiIp, whatsapp_api_glassfish} from '../../../../config/constants';
import * as UiConsts from '../../../../config/UiConstants.js'
import Select from 'react-select';

export class WhatsappConfirmDeposit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order_numbers: '',
            order_numbers_array: [],
            totalOrderAmount: '',
            depositAmount: '',
            balance: '',
            phone: this.props.phone,
            loading: false,
            visible: false,
            sendToFindShirt:'no',
            sendToFindShirtOptions: [
                {
                    "category": "sendToFindShirt",
                    "label": "yes",
                    "value": "yes",
                    "key": "yes"
                },
                {
                    "category": "sendToFindShirt",
                    "label": "No",
                    "value": "no",
                    "key": "no"
                },
            ]
        }
    }

    componentDidMount(){
      //  console.log("+++++ WhatsappConfirmDeposit componentDidMount");

        if(this.props.order_num != 0){
            console.log("order num is not zero:"+this.props.order_num);
            this.setState({
                order_numbers : this.props.order_num
            })
        }else{
            console.log("order num is zero:"+this.props.order_num);
        }
    }

    handleDropDownChanges = (value) => {
        console.log("docx19 handleDropDownChanges");
        console.log('docx191 You\'ve sss:', value);
        console.log("docx192 category alone:" + value.category);
        console.log('docx193 You\'ve selected:', value.value + " " + value.category);
        console.log("docx195 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }

  
    checkOrderNumbers = () => {
        console.log("snmny5 +++++ checkOrderNumbers")
        console.log("snmny52 this.state.order_numbers:"+this.state.order_numbers)

        let tempOrderNumList = [];

        //CHECK IF COMMA EXISTS
        console.log("before include check:"+this.state.order_numbers);

        //typeof value == "string" && value.indexOf('$') > -1

        if (this.state.order_numbers.toString().includes(",")) {
       // if (typeof this.state.order_numbers == "string" && this.state.order_numbers.indexOf(',') > -1) {
            console.log("snmny53 order number includes comma");

            //GET ARRAY OF ORDER NUMBERS
            let tempList = this.state.order_numbers.toString();
            tempOrderNumList = tempList.split(',');
            console.log("snmny54  split on commas:" + tempOrderNumList.toString());

            //this.validateOrderNums(tempOrderNumList);

        } else {
            console.log("snmny55 no comma in order num, just one order num");

            //GET SINGLE ORDER NUM
            //let tempOrderNumList = [];

            tempOrderNumList.push(this.state.order_numbers.toString().trim());
            console.log("snmny56 added order num to tempOrderNumList:" + tempOrderNumList.toString())

            //VALIDATE ORDER NUM
            //this.validateOrderNums(tempOrderNumList);
        }

        for (var i = 0; i < tempOrderNumList.length; i++) {
            console.log("entx75 processing order num:" + tempOrderNumList[i]);

            //CHECK LENGTHS
            if (tempOrderNumList[i].length != 5) {
                alert("Order num " + tempOrderNumList[i] + " must be equal 5 chars");
                //this.setState({ loading: false })
                tempOrderNumList = false;
                break;

                //CHECK IF NUMBER
            } else if (isNaN(tempOrderNumList[i])) {
                alert("Order num " + tempOrderNumList[i] + " must be a number");
                //this.setState({ loading: false })
                tempOrderNumList = false;
                break;

            } else {
                console.log("enxt23 orderNum is ok:" + tempOrderNumList[i]);
                //this.markSingleOrderDelivered(tempOrderNumList[i]);
                // this.setState({ loading: false })
            }
        }

        console.log("entx76 tempOrderNumList:" + tempOrderNumList.toString());
        console.log("entx76 tempOrderNumList:" + tempOrderNumList);

        if(tempOrderNumList){
            console.log("snmny591 tempOrderNumList is true:");
            this.sendDepositConfirmation(tempOrderNumList)
            // this.setState({
            //     order_numbers_array:tempOrderNumList
            // }, () => this.sendDepositConfirmation())
        }else{
            alert("one of the order numbers is bad double check")
        }
       

        //return tempOrderNumList;
    }


    sendDepositConfirmation = (order_numbers_array) => {
        console.log("++++++ send_dep_many_orders +++")
        if (this.state.order_numbers == '' || this.state.order_numbers.length < 5) {
            alert("no order num or invalid order num")
        } else if (!this.props.phone) {
            alert("no phone number")
        } else if (this.state.totalOrderAmount == '') {
            alert("no  totalOrderAmount")
        } else if (this.state.depositAmount == '') {
            alert("no phone depositAmount")
        } else if ((this.state.totalOrderAmount - this.state.depositAmount) < 0) {
            alert(" balance is less that zero")
        }else {

            this.setState({ loading: true })

            var d = new Date();
            let now = moment().format('MMMM Do, h:mm:ss a');

//http://localhost:8080/PrintBReporting/webresources/whatsappApi/send_dep_many_orders

            axios.post(whatsapp_api_glassfish + 'send_dep_many_orders', {
           // axios.post('http://localhost:8080/PrintBReporting/webresources/whatsappApi/send_dep_many_orders', {
                apiKey: "asdf@asdfasdf",
                order_numbers: this.state.order_numbers,
                order_numbers_array: order_numbers_array,
                phone: this.props.phone,
                totalOrderAmount: this.state.totalOrderAmount,
                depositAmount: this.state.depositAmount,
                balance: (this.state.totalOrderAmount - this.state.depositAmount),
                sendToFindShirt: this.state.sendToFindShirt,
                enteredBy: "info@printboda.com",
            })
                .then((response) => {
                    this.setState({ loading: false })
                    console.log(response.data);

                    if(response.data.result){
                        console.log("success message sent");

                        alert(response.data.message);

                        this.setState({
                            order_numbers:'',
                            order_numbers_array:[],
                            totalOrderAmount:'',
                            depositAmount:'',
                            balance:'',
                            sendToFindShirt:'no'

                        })
                    }else{
                        alert("error:"+response.data.message)
                    }


                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ loading: false })
                });

        }
    }


    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    showUI = () => {
        console.log("setVisible")

        if (this.state.visible) {
            console.log("state is " + this.state.visible)
            this.setState({
                visible: false
            })
        } else if (!this.state.visible) {
            console.log("state is " + this.state.visible)
            this.setState({
                visible: true
            })
        }
    }

    render() {

        const sendButton = this.state.depositAmount != '' && this.state.totalOrderAmount != ''
            ? <Button color='green' onClick={this.checkOrderNumbers}> SEND DEP CONF </Button>
            : ''

        const wholeUi = this.state.visible
            ? <div>
                <Form onSubmit={this.checkOrderNumbers}>

                    <label>Enter Order Numbers Separted by commas:{this.state.order_numbers}</label>
                    <Form.Input
                        fluid
                        icon='hashtag'
                        iconPosition='left'
                        placeholder='Order Number'
                        type='text'
                        name="order_numbers"
                        value={this.state.order_numbers}
                        onChange={this.handleTextInputChange}
                    />

                    <label>Total Order Amount (total of all orders):{toCurrency(this.state.totalOrderAmount)}</label>
                    <Form.Input
                        fluid
                        icon='money'
                        iconPosition='left'
                        placeholder='Total Order Amount'
                        type='number'
                        name="totalOrderAmount"
                        value={this.state.totalOrderAmount}
                        onChange={this.handleTextInputChange}
                    />


                    <label>Deposit:{toCurrency(this.state.depositAmount)}</label>
                    <Form.Input
                        fluid
                        icon='money'
                        iconPosition='left'
                        placeholder='Deposit Amount'
                        type='number'
                        name="depositAmount"
                        value={this.state.depositAmount}
                        onChange={this.handleTextInputChange}
                    />
                    <label>Balance:{toCurrency(this.state.totalOrderAmount - this.state.depositAmount)}</label>
                    <Form.Input
                        fluid
                        icon='money'
                        iconPosition='left'
                        placeholder='Balance'
                        type='number'
                        name="balance"
                        value={this.state.totalOrderAmount - this.state.depositAmount}
                        onChange={this.handleTextInputChange}
                    />

                    <label> SEND TO FIND SHIRT </label>
                    <Select
                        name="form-field-name"
                        value={this.state.sendToFindShirt}
                        options={this.state.sendToFindShirtOptions}
                        onChange={this.handleDropDownChanges}
                        searchable={false}
                        clearable={false}
                    />

                    {sendButton}
                </Form>

            </div>
            : ''

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <Divider horizontal>{'CONFIRM DEPOSIT'}</Divider>
                <Button color='violet' onClick={this.showUI} fluid>CONFIRM DEPOSIT</Button>
                {wholeUi}
            </div>
        )
    }
}

export default WhatsappConfirmDeposit;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/WhatsappConfirmDeposit.js